<template>
  <ul class="pl-0">
    <li
      v-for="(item, index) in sanitizedDescription"
      :key="item + '_' + index"
      class="d-inline desc-item"
      v-html="item"
    />
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import DOMPurify from 'dompurify'

export default defineComponent({
  name: 'ProductShortDescription',
  props: {
    description: {
      type: Array as PropType<string[]>,
      required: true
    }
  },
  setup(props) {
    const sanitizedDescription = computed(() =>
      props.description.map((item) => DOMPurify.sanitize(item))
    )

    return { sanitizedDescription }
  }
})
</script>

<style lang="scss" scoped>
.desc-item {
  word-wrap: normal;
  &::after {
    content: '○';
    font-size: 0.9rem;
    padding: 0 5px 0 5px;
  }
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
    &::after {
      content: '';
    }
  }
}
</style>
